import TemplateView from '../../../TemplateView'
import messageResource from "../../../messageResource";

class ScopeCellContainer extends TemplateView {
    constructor({
        innerElement = null
    }) {
        super()

        this.params = {
            innerElement,
        }

        this.state = {
            labelKey: '',
        }

        this.onStateChanged(() => {
            this.updateLabel()
        })
    }

    templateHtml() {
        return "<div class='userPanelScopeCellContainer block'>" +
               "    <div class='label blockHeader'></div>" +
               "    <div class='content'></div>" +
               "</div>"
    }

    afterRender() {
        this.params.innerElement.init(this.$el.find('.content'))

        this.$label = this.find('.label');
    }

    updateLabel() {
        this.$label.text(messageResource.getMessage(this.state.labelKey))
    }
}

export default ScopeCellContainer



// WEBPACK FOOTER //
// ./web/js/panels/user/permissions/ScopeCellContainer.js